import { env } from '@/config/env';

export function normalizeImageSrc(src, base = '') {
  const raw = String(src || '').trim();
  if (!raw) {
    return '';
  }
  if (/^(?:https?:)?\/\//i.test(raw) || /^(?:data|blob):/i.test(raw)) {
    return raw;
  }
  const root = String(base || env.BASE_OSS || '').replace(/\/+$/, '');
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  return root ? `${root}${path}` : path;
}
